import { useMutation } from "@apollo/react-hooks";
import { Modal, TextField } from "@shopify/polaris";
import { get } from "lodash";
import React, { useCallback, useReducer } from "react";
import { UPDATE_MAPPING_ORDER_QUANTITY } from "../../../graphql/mutations";
import { arrInvalid, handleError, reducerFn } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";

export default function MappingOrderUpdateQuantity({
    open,
    onClose,
    ids,
    onCompleted,
    item,
}) {
    const [state, setState] = useReducer(reducerFn, {
        quantity: (get(item, "quantity") || "") + "" || "1",
    });

    const { setNotify, toggleToast } = useToastContext();

    const [setDelay] = useTimeout();
    const [updateMappingOrderQuantity, { loading }] = useMutation(
        UPDATE_MAPPING_ORDER_QUANTITY,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Update quantity for Mapping Order success",
                    err: false,
                });

                onClose && onClose();
                setDelay(() => {
                    onCompleted && onCompleted();
                }, 2000);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const handleSubmit = useCallback(() => {
        if (arrInvalid(ids)) return;

        updateMappingOrderQuantity({
            variables: {
                ids,
                quantity: +state.quantity,
            },
        });
    }, [
        updateMappingOrderQuantity,
        setNotify,
        toggleToast,
        ids,
        state.quantity,
    ]);

    const handleStateChange = useCallback((quantity) => {
        setState({ quantity });
    }, []);

    return (
        <Modal
            title="Update Quantity"
            sectioned
            open={open}
            onClose={onClose}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
        >
            <TextField
                label="Quantity"
                value={state.quantity}
                type="number"
                id="quantity"
                min={1}
                onChange={handleStateChange}
            />
        </Modal>
    );
}
